import React from "react";

export const StarIcon = ({ className, color = "white" }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
                fill={color}
            />
        </svg>
    );
};

export const CartIcon = ({ className, color = "white" }) => {
    return (
        <svg className={className} width="37" height="45" viewBox="0 0 37 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M36.8182 45H0L5.11364 8.18182H12.2727V5.11364C12.2727 2.28989 14.5626 0 17.3864 0H19.4318C22.2556 0 24.5455 2.28989 24.5455 5.11364V8.18182H31.7045L36.8182 45ZM22.5 5.11364C22.5 3.41898 21.1265 2.04545 19.4318 2.04545H17.3864C15.6917 2.04545 14.3182 3.41898 14.3182 5.11364V8.18182H22.5V5.11364ZM24.5455 10.2273V14.3182H22.5V10.2273H14.3182V14.3182H12.2727V10.2273H7.15909L2.04545 42.9545H34.7727L29.6591 10.2273H24.5455Z"
                fill={color}
            />
        </svg>
    );
};

export const ErrorIcon = ({ className, color = "white" }) => {
    return (
        <svg className={className} width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.3423 4.63866C10.1671 4.46355 9.88328 4.46355 9.70817 4.63866L7.48862 6.85821L5.26885 4.63866C5.09373 4.46355 4.80987 4.46355 4.63475 4.63866C4.45964 4.81378 4.45964 5.09764 4.63475 5.27275L6.85453 7.4923L4.63475 9.71185C4.45964 9.88697 4.45964 10.1708 4.63475 10.3459C4.72242 10.4336 4.837 10.4773 4.9518 10.4773C5.0666 10.4773 5.18118 10.4336 5.26885 10.3459L7.48862 8.12639L9.70817 10.3459C9.79584 10.4336 9.91041 10.4773 10.0252 10.4773C10.14 10.4773 10.2546 10.4336 10.3423 10.3459C10.5174 10.1708 10.5174 9.88697 10.3423 9.71185L8.12271 7.4923L10.3423 5.27275C10.5174 5.09764 10.5174 4.81355 10.3423 4.63866Z"
                fill={color}
            />
            <path
                d="M12.8027 2.19735C11.3858 0.780508 9.50192 0 7.49807 0C5.49422 0 3.61077 0.780283 2.19371 2.19735C-0.731236 5.12229 -0.731236 9.88157 2.19371 12.8063C3.61033 14.2231 5.49444 15.0036 7.49807 15.0036C9.50214 15.0036 11.386 14.2234 12.8029 12.8063C14.2197 11.3897 15 9.50556 15 7.50171C14.9998 5.49809 14.2195 3.61419 12.8027 2.19735ZM12.169 12.1722C10.9214 13.4195 9.26267 14.1068 7.49829 14.1068C5.73413 14.1068 4.07536 13.4198 2.82802 12.1722C0.252864 9.59704 0.252864 5.4066 2.82802 2.83144C4.07558 1.58389 5.73391 0.896878 7.49807 0.896878C9.26223 0.896878 10.921 1.58389 12.1683 2.83122C13.4157 4.07855 14.1029 5.73733 14.1031 7.50171C14.1031 9.26609 13.4163 10.9249 12.169 12.1722Z"
                fill={color}
            />
        </svg>
    );
};
